import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'components/Button/styles';

import * as S from './style';

import { ForwardAlertProps } from './types';

const ForwardAlert: React.FC<ForwardAlertProps> = ({
  confirmedCriticality,
  setNoteValue,
  note,
}) => {
  const handleConfirmedCriticality = () => {
    setNoteValue(note);
    confirmedCriticality();
  };

  const intl = useIntl();

  const labelTextArea =
    'ENDUSER.DRAWER.CRITICAL.FORWARDALERT.TEXTAREA.PLACEHOLDER';

  return (
    <>
      <S.DrawerContentTitle data-testid="ForwardAlertTitle">
        <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.TITLE" />
      </S.DrawerContentTitle>

      <S.DrawerContentSubTitle>
        <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.SUBTITLE" />
      </S.DrawerContentSubTitle>

      <S.DrawerContainerBox>
        <S.DrawerContentSubTitle bold>
          <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.SUBTITLE.OBS" />
        </S.DrawerContentSubTitle>

        <S.TextAreaForward
          full
          cleanable={false}
          data-testid="textAreaForwardInput"
          onChange={(event: any) => setNoteValue(event.target.value)}
          label={intl.formatMessage({
            id: labelTextArea,
          })}
          value={note}
        />
      </S.DrawerContainerBox>

      <S.DrawerBoxFooter>
        <Button onClick={handleConfirmedCriticality}>
          <FormattedMessage id="CONFIRM.CONFIRM.DEFAULT" />
        </Button>
      </S.DrawerBoxFooter>
    </>
  );
};

export default ForwardAlert;
